<template>
  <div class="text-center">
    <validationObserver v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(editPurchase)">
        <h5 class="mb-2">Payment Collection</h5>
        <div>
          <input-form
              v-model="remainingDays"
              placeholder="Enter Validity"
              :validate="`required|min_value:${remaining}`"
              name="Validity"
              :label="'Validity'"
              class="text-left"
          />
        </div>
        <div class="d-flex justify-content-center gap-1 mb-4">
          <mainstatus status="DUE" />
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.5 12.5H19.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.5 5.5L19.5 12.5L12.5 19.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <mainstatus status="PAID" />
        </div>

        <b-button class="text-white d-flex gap-1 m-auto" variant="warning" type="submit" :disabled="requestLoading">
          <spinner-loading v-if="requestLoading"></spinner-loading>
          <span v-else>Confirm</span>
        </b-button>
      </b-form>
    </validationObserver>
  </div>
</template>

<script>
import mainstatus from '@/components/table/status'

export default {
  props: {
    requestLoading: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
    },
    remaining: {
      type: String,
    }
  },
  data () {
    return {
      remainingDays: ''
    }
  },
  components: { mainstatus },
  methods: {
     addDays(date, days) {
      const result = new Date(date)
      result.setDate(result.getDate() + days)
      return result.toISOString().split('T')[0]
     },
    editPurchase () {
      this.$emit('editPurchase', {
        validity_days: this.remainingDays
      })
    }
  },
  watch: {
  },
  created () {
    this.remainingDays = this.remaining
  }
}
</script>

<style lang="scss" scoped>
</style>
